import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { AboutUsHeader } from './AboutUsHeader';
import { AboutUsHeaderContent } from './AboutUsHeaderContent';
import { AboutUsHeaderFigure } from './AboutUsHeaderFigure';

type AboutUsHeaderFCProps = {
  index: number;
  data: AboutUsHeader;
  updateData: (element: IElement, index: number) => void;
};

export const AboutUsHeaderFC = ({
  index,
  data,
  updateData,
}: AboutUsHeaderFCProps) => {
  const update = (fieldsToUpdate: Partial<AboutUsHeader>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="about-us-header">
          <AboutUsHeaderContent data={data} update={update} />
          <AboutUsHeaderFigure data={data} update={update} />
        </div>
      </ElementWrapper>
    </>
  );
};
